module.exports = __webpack_public_path__ + "img/vote_tips.765da13e.png";